import { Loader2, Pause } from 'lucide-react';
import { PhaseControls } from './PhaseControls';
import { runBtnClass } from './controls';
import { useLanguage } from '../../contexts/LanguageContext';

// Shown in a step panel while a "Run steps 1 to 5" pipeline holds this phase but its
// own inputs aren't ready yet (an earlier phase hasn't reached it). It replaces both
// the phase's stale results and its "run an earlier step first" hint with a single
// disabled control — the hint would be wrong, because the run is what will get here.
//
// Unless it won't. `held` is a run the user paused: the earlier step is NOT on its
// way and will not be until Reprendre is pressed. A spinner is a claim that something
// is running, and that is the one thing this state must not claim.
export function PendingPhase({ held }: { held?: boolean }) {
  const { t } = useLanguage();
  return (
    <PhaseControls>
      <button type="button" disabled className={runBtnClass}>
        {held ? <Pause className="h-4 w-4" /> : <Loader2 className="h-4 w-4 animate-spin" />}
        {t(held ? 'notice.run.held' : 'notice.run.waiting')}
      </button>
    </PhaseControls>
  );
}
